"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    studentsSummary: {
        title: 'Assigned to',
        students: 'Students submitted',
        unattemptedStudents: 'Students unattempted',
        reschedule: 'Reschedule',
        seeStudents: 'See students >',
    },
};
